export const skills = [
  {
    title: "HTML5",
    src: "https://img.icons8.com/color/96/000000/html-5--v1.png",
  },
  {
    title: "CSS3",
    src: "https://img.icons8.com/color/96/000000/css3.png",
  },

  {
    title: "SASS",
    src: "https://img.icons8.com/color/96/000000/sass-avatar.png",
  },

  {
    title: "TailwindCSS",
    src: "https://img.icons8.com/color/96/000000/tailwindcss.png",
  },

  {
    title: "JavaScript",
    src: "https://img.icons8.com/color/96/000000/javascript--v1.png",
  },
  {
    title: "ReactJS",
    src: "https://img.icons8.com/color/96/000000/react-native.png",
  },

  {
    title: "TypeScript",
    src: "https://img.icons8.com/color/96/000000/typescript.png",
  },

  {
    title: "NextJS",
    src: "https://img.icons8.com/color/96/000000/nextjs.png",
  },
  /*  {
    title: "Angular",
    src: "https://img.icons8.com/?size=100&id=l9a5tcSnBwcf&format=png&color=000000",
  }, */

  /*  {
    title: "Bootstrap",
    src: "https://img.icons8.com/?size=100&id=g9mmSxx3SwAI&format=png&color=000000",
  }, */

  /* {
    title: "Material UI",
    src: "https://img.icons8.com/color/96/000000/material-ui.png",
  },
  {
    title: "Chakra UI",
    src: "https://img.icons8.com/color/96/000000/chakra-ui.png",
  }, */

  {
    title: "Git & GitHub",
    src: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/96/000000/external-github-with-cat-logo-an-online-community-for-software-development-logo-color-tal-revivo.png",
  },
  /*  {
    title: "Firebase",
    src: "https://img.icons8.com/?size=100&id=62452&format=png&color=000000",
  }, */
];
